import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: number;
  center?: boolean;
}

export function Spinner({ size = 24, center }: SpinnerProps): JSX.Element {
  const node = (
    <span className={styles.root} style={{ width: size, height: size }} aria-label="Завантаження" />
  );
  if (center) return <div className={styles.center}>{node}</div>;
  return node;
}
